import type { ReactNode } from "react";

import { BlockFormatButtons } from "./BlockFormatButtons";
import { HeadingFormatButtons } from "./HeadingFormatButtons";
import { InlineFormatButtons } from "./InlineFormatButtons";
import { LinkButton } from "./LinkButton";

import * as styles from "./Toolbar.styles";

interface Props {
  toolbarInfo?: ReactNode;
}

const Toolbar = ({ toolbarInfo }: Props) => {
  return (
    <div css={styles.toolbar}>
      <div css={styles.toolbarButtons}>
        <InlineFormatButtons />
        <HeadingFormatButtons />
        <LinkButton />
        <BlockFormatButtons />
      </div>
      {!!toolbarInfo && <div>{toolbarInfo}</div>}
    </div>
  );
};

export { Toolbar };
